"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const airbrake_js_1 = __importDefault(require("airbrake-js"));
const tracing_1 = require("../tracing");
const opentracing_1 = require("opentracing");
const tracingImpl = (notify, spanName) => (error, ctx) => {
    if (ctx && ctx.tracing) {
        const { tracer, span } = ctx.tracing;
        return tracing_1.trace(tracer, span, spanName, async (span) => {
            span.setTag(opentracing_1.Tags.SPAN_KIND, opentracing_1.Tags.SPAN_KIND_RPC_CLIENT);
            const tracerHeaders = {};
            tracer.inject(span, opentracing_1.FORMAT_HTTP_HEADERS, tracerHeaders);
            await notify(withExtraContext(error, tracerHeaders), ctx);
        });
    }
    else {
        return notify(error, ctx);
    }
};
const withExtraContext = (notice, extraContext) => {
    if (notice && (notice.error || notice.context)) {
        return Object.assign({}, notice, { context: Object.assign({}, notice.context, extraContext) });
    }
    else {
        return { error: notice, context: extraContext };
    }
};
const requestIdImpl = (notify) => (error, ctx) => {
    if (ctx && ctx.req_id) {
        return notify(withExtraContext(error, { req_id: ctx.req_id }), ctx);
    }
    return notify(error, ctx);
};
const airbrakeNotifier = (platform, projectId, projectKey, environment) => {
    if (projectId == null || projectKey == null) {
        return throwingNotifier;
    }
    const airbrake = new airbrake_js_1.default({
        projectId,
        projectKey
    });
    airbrake.addFilter(function (notice) {
        notice.context.environment = environment;
        const componentList = [platform];
        if (notice.context.component != null) {
            componentList.push(notice.context.component);
        }
        notice.context.component = componentList.join(".");
        return notice;
    });
    return {
        notify: requestIdImpl(tracingImpl(airbrake.notify.bind(airbrake), "errornotifier/airbrakeNotifier"))
    };
};
exports.airbrakeNotifier = airbrakeNotifier;
const nullNotifier = {
    notify: () => { }
};
exports.nullNotifier = nullNotifier;
const logNotifier = (logger) => ({
    notify: error => logger.error().log({
        error: JSON.stringify(error),
        context: "errornotifier"
    })
});
exports.logNotifier = logNotifier;
const throwingNotifier = {
    notify: error => {
        throw error;
    }
};
const defaultNotifier = (name, config, logger) => {
    const l = logger.with({
        context: "error_notification"
    });
    if (config.CLIENT_AIRBRAKE_PROJECT_ID != null) {
        l.info().log({
            context: "error_notification",
            project_id: config.CLIENT_AIRBRAKE_PROJECT_ID,
            env: config.CLIENT_AIRBRAKE_ENVIRONMENT,
            msg: `logging errors to Airbrake ${config.CLIENT_AIRBRAKE_ENVIRONMENT} env on project ${config.CLIENT_AIRBRAKE_PROJECT_ID}`
        });
        return airbrakeNotifier(name, config.CLIENT_AIRBRAKE_PROJECT_ID, config.CLIENT_AIRBRAKE_PROJECT_KEY, config.CLIENT_AIRBRAKE_ENVIRONMENT);
    }
    else {
        l.warn().log({
            msg: "logging errors with log error notifier"
        });
        return logNotifier(logger);
    }
};
exports.defaultNotifier = defaultNotifier;
const _test = {
    tracingImpl,
    requestIdImpl,
    withExtraContext
};
exports._test = _test;
//# sourceMappingURL=index.js.map